<template>
	<div>
		<div class="first_line">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true">
						<el-form-item label="选择月份">
							<el-date-picker label="" type="monthrange" value-format="yyyy-MM" v-model="query.time"
								size="small" style="margin-left: 10px;"></el-date-picker>
						</el-form-item>
						<el-form-item label="选门店">
							<el-select label="门店" v-model="query.storeId" placeholder="选择门店" size="small">
								<el-option v-for="item in storeName" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-button @click="handleSelect()" size="small" style="margin-left: 10px;">筛选</el-button>
						<!-- <el-button @click="exportin()" type="success" size="small" style="margin-left: 10px;">导入</el-button> -->
						<input type="file" name="file" style="display: none;" id="sj" @change="xuanzhe($event)" />
						<el-button @click="exportout()" type="primary" size="small"
							style="margin-left: 10px;">导出</el-button>
						<el-button @click="add()" size="small" type="primary"
							style="margin-left: 10px;">新建门店成本</el-button>
					</el-form>
				</el-col>
			</el-row>
		</div>
		<el-table :cell-style="{'text-align':'center'}" :data="firstData"
			:header-cell-style="{ 'text-align': 'center', 'color': '#737373', 'border-color': '#dfdfdf','font-size': '14px'}">
			<el-table-column width="150" prop="storeName" label="门店"></el-table-column>
			<el-table-column label="初始成本" width="auto">
				<el-table-column width="200" prop="zhuangXiu" label="装修">
				</el-table-column>
				<el-table-column width="200" prop="ruanZhuang" label="软装">
				</el-table-column>
				<el-table-column width="200" prop="sheBei" label="设备">
				</el-table-column>
				<el-table-column width="200" prop="qiTa" label="其他">
				</el-table-column>
			</el-table-column>
			<el-table-column label="操作" width="217">
				<template slot-scope="scope">
					<el-button @click="dfirst=true,show1(scope.row.id)" type="primary" size="small">编辑</el-button>
					<el-button @click="deleteFirst(scope.row.id)" type="danger" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div>
			<el-pagination background @current-change="handleCurrentChange01" style="margin-top: 30px;"
				layout="total, sizes, prev, pager, next" :page-size="query2.pageSize" :current-page="query2.pageNum"
				:total="query2.total">
			</el-pagination>
		</div>
		<div>
			<!-- ---------------------------------------------------第二个表-------------------------------------------------------------------------- -->
			<el-button @click="add2()" size="small" type="primary"
				style="margin-left: 10px;margin-top: 10px;">新建月度成本</el-button>
			<el-table :data="data" :cell-style="{'text-align':'center',}" style="margin-top: 20px;"
				:header-cell-style="{ 'text-align': 'center', 'color': '#737373', 'border-color': '#dfdfdf','font-size': '14px'}">
				<el-table-column prop="storeName" label="门店" width="150"></el-table-column>
				<el-table-column prop="time" label="月份" width="150"></el-table-column>
				<el-table-column label="初始成本摊分" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.ftanFen" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.ftanFen}}</span>
					</template>
				</el-table-column>
				<el-table-column label="发型师成本" width="100">
					<template slot-scope="scope">
						<span v-show="!scope.row.show">{{scope.row.worker}}</span>
					</template>
				</el-table-column>
				<el-table-column label="管理费" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.guanLi" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.guanLi}}</span>
					</template>
				</el-table-column>
				<el-table-column label="租金" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.zuJin" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.zuJin}}</span>
					</template>
				</el-table-column>
				<el-table-column label="水电费" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.shuiDian" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.shuiDian}}</span>
					</template>
				</el-table-column>
				<el-table-column label="杂费" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.zaFei" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.zaFei}}</span>
					</template>
				</el-table-column>
				<el-table-column label="潮剪计提(按净利润20%计算)" width="100">
					<template slot-scope="scope">
						<el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.chaoJian" size="small">
						</el-input>
						<span v-show="!scope.row.show">{{scope.row.chaoJian}}</span>
					</template>
				</el-table-column>
				<el-table-column label="备注" width="150">
					<template slot-scope="scope">
						<el-input type="textarea" placeholder="请输入内容" v-show="scope.row.show"
							v-model="scope.row.remark"></el-input>
						<span v-show="!scope.row.show">{{scope.row.remark}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button @click="show2(scope.row.id)" type="primary" size="small">编辑</el-button>
						<el-button @click="deleteMonth(scope.row.id)" type="danger" size="small">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<div>
				<el-pagination background @current-change="handleCurrentChange" style="margin-top: 30px;"
					layout="total, sizes, prev, pager, next" :page-size="query.pageSize" :current-page="query.pageNum"
					:total="query.total">
				</el-pagination>
			</div>
		</div>
		<!-- 初始成本弹窗 -->
		<el-dialog :visible.sync="dfirst" class="newcost" width="400px">
			<el-form style="width:530px;">
				<el-form-item label="门店名称" label-width="80px">
					<el-input v-model="firstDataEdit.storeName"
						style="width:250px; margin-left:10px;margin-right:10rpx"></el-input>
				</el-form-item>
				<el-form-item label="装修 ￥" label-width="80px">
					<div style="display: flex;">
						<el-input v-model="firstDataEdit.zhuangXiu" style="width:250px; margin-left:10px;"></el-input>
						<div style="width: 10px;"></div>
						<i class="el-icon-circle-plus-outline" style="margin-top: 13px;" @click="addlist(1)"
							size="big"></i>
					</div>
				</el-form-item>
				<div class="titlelist" style="margin-left: 90px;" v-if="firstDataEdit.zhuangXiuDetail.length>0">
					<div>项目</div>
					<div>数量</div>
					<div>金额</div>
				</div>
				<div style="position: relative;top: -10px;margin-left: 91px;margin-bottom: 10px;" v-if="dfirst"
					v-for="(item,index) in firstDataEdit.zhuangXiuDetail" :key="index">
					<el-input v-model="item.name" style="width:76px;"></el-input>
					<el-input v-model="item.num" style="width: 76px;margin-left: 10px;"></el-input>
					<el-input v-model="item.money" style="width:76px;margin-left: 10px;margin-right: 10px;"></el-input>
					<i class="el-icon-remove-outline" @click="downlist(index,1)" size="big"></i>
				</div>
				<!--  -->
				<el-form-item label="软装 ￥" label-width="80px">
					<div style="display: flex;">
						<el-input v-model="firstDataEdit.ruanZhuang" style="width:250px; margin-left:10px;"></el-input>
						<div style="width: 10px;"></div>
						<i class="el-icon-circle-plus-outline" style="margin-top: 13px;" @click="addlist(2)"
							size="big"></i>
					</div>
				</el-form-item>
				<div class="titlelist" style="margin-left: 90px;" v-if="firstDataEdit.ruanZhuangDetail.length>0">
					<div>项目</div>
					<div>数量</div>
					<div>金额</div>
				</div>
				<div style="position: relative;top: -10px;margin-left: 91px;margin-bottom: 10px;" v-if="dfirst"
					v-for="(item,index) in firstDataEdit.ruanZhuangDetail">
					<el-input v-model="item.name" style="width:76px;"></el-input>
					<el-input v-model="item.num" style="width: 76px;margin-left: 10px;"></el-input>
					<el-input v-model="item.money" style="width:76px;margin-left: 10px;margin-right: 10px;"></el-input>
					<i class="el-icon-remove-outline" style="margin-top: 13px;" @click="downlist(index,2)"
						size="big"></i>
				</div>
				<!--  -->
				<el-form-item label="设备 ￥" label-width="80px">
					<div style="display: flex;">
						<el-input v-model="firstDataEdit.sheBei" style="width:250px; margin-left:10px;"></el-input>
						<div style="width: 10px;"></div>
						<i class="el-icon-circle-plus-outline" style="margin-top: 13px;" @click="addlist(3)"
							size="big"></i>
					</div>
				</el-form-item>
				<div class="titlelist" style="margin-left: 90px;" v-if="firstDataEdit.sheBeiDetail.length>0">
					<div>项目</div>
					<div>数量</div>
					<div>金额</div>
				</div>
				<div style="position: relative;top: -10px;margin-left: 91px;margin-bottom: 10px;" v-if="dfirst"
					v-for="(item,index) in firstDataEdit.sheBeiDetail">
					<el-input v-model="item.name" style="width:76px;"></el-input>
					<el-input v-model="item.num" style="width: 76px;margin-left: 10px;"></el-input>
					<el-input v-model="item.money" style="width:76px;margin-left: 10px;margin-right: 10px;"></el-input>
					<i class="el-icon-remove-outline" @click="downlist(index,3)" size="big"></i>
				</div>
				<el-form-item label="其他 ￥" label-width="80px">
					<div style="display: flex;">
						<el-input v-model="firstDataEdit.qiTa" style="width:250px; margin-left:10px;"></el-input>
						<div style="width: 10px;"></div>
						<i class="el-icon-circle-plus-outline" style="margin-top: 13px;" @click="addlist(4)"
							size="big"></i>
					</div>
				</el-form-item>
				<div class="titlelist" style="margin-left: 90px;" v-if="firstDataEdit.qiTaDetail.length>0">
					<div>项目</div>
					<div>数量</div>
					<div>金额</div>
				</div>
				<div style="position: relative;top: -10px;margin-left: 91px;margin-bottom: 10px;" v-if="dfirst"
					v-for="(item,index) in firstDataEdit.qiTaDetail">
					<el-input v-model="item.name" style="width:76px;"></el-input>
					<el-input v-model="item.num" style="width: 76px;margin-left: 10px;"></el-input>
					<el-input v-model="item.money" style="width:76px;margin-left: 10px;margin-right: 10px;"></el-input>
					<i class="el-icon-remove-outline" @click="downlist(index,4)" size="big"></i>
				</div>
				<el-form-item label="备注" label-width="80px">
					<el-input type="textarea" v-model="firstDataEdit.firstRemark" rows="3"
						style="width:250px;margin-left: 10px;"></el-input>
				</el-form-item>
			</el-form>
			<div align="center">
				<el-button @click="saveFirstCost(firstDataEdit.id)" type="primary" size="small">保存</el-button>
				<el-button @click="dfirst=false" size="small">取消</el-button>
			</div>
		</el-dialog>
		<!-- 月度成本弹窗 -->
		<el-dialog :visible.sync="dsecond" width="600px">
			<el-form style="width: 300px;">
				<el-form-item label="门店名称" align="center" label-width="150px" label-position="left">
					<el-input v-model="edata.storeName" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="月份" align="center" label-width="150px">
					<el-date-picker value-format="yyyy-MM" v-model="edata.time" type="month" style="width: 250px;">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="初始成本摊分" align="center" label-width="150px">
					<el-input v-model="edata.ftanFen" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="发型师总成本" align="center" label-width="150px">
					<div style="display: flex;width: 320px;">
						<el-input v-model="edata.worker" style="width: 250px;" class="it_width"></el-input>
						<div style="width: 10px;"></div>
						<i class="el-icon-circle-plus-outline" style="margin-top: 13px;" @click="addmouthlist(1)"
							size="big"></i>
					</div>
				</el-form-item>
				<div class="titlelist" v-if="edata.workerDetail.length>0">
					<div>项目</div>
					<div>数量</div>
					<div>金额</div>
				</div>
				<div style="position: relative;top: -10px;margin-left:150px;margin-bottom: 10px;width:300px"
					v-for="(item,index) in edata.workerDetail" :key="index">
					<el-input v-model="item.name" style="width:76px;"></el-input>
					<el-input v-model="item.num" style="width: 76px;margin-left: 10px;"></el-input>
					<el-input v-model="item.money" style="width:76px;margin-left: 10px;margin-right: 10px;"></el-input>
					<i class="el-icon-remove-outline" @click="downmouthlist(index,1)" size="big"></i>
				</div>
				<el-form-item label="管理费" align="center" label-width="150px">
					<el-input v-model="edata.guanLi" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="租金" align="center" label-width="150px">
					<el-input v-model="edata.zuJin" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="水电费" align="center" label-width="150px">
					<el-input v-model="edata.shuiDian" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="杂费" align="center" label-width="150px">
					<el-input v-model="edata.zaFei" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="潮剪计提" align="center" label-width="150px">
					<el-input v-model="edata.chaoJian" class="it_width"></el-input>
				</el-form-item>
				<el-form-item label="备注" align="center" label-width="150px">
					<el-input type="textarea" v-model="edata.remark" style="width: 250px; height: auto;"></el-input>
				</el-form-item>
			</el-form>
			<div align="center">
				<el-button @click="saveMonthCost(edata.id)" type="primary" size="small">保存</el-button>
				<el-button @click="dsecond=false" size="small">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		url
	} from '../../../utils/index.js'
	export default {
		data() {
			return {
				ishow: true,
				list: [],
				dfirst: false,
				dsecond: false,
				url: url(),
				storeName: [{
					id: '',
					label: "全部",
					value: undefined,
				}, ],
				firstData: [{
					storeName: '',
					zhuangXiu: '',
					ruanZhuang: '',
					sheBei: '',
					qiTa: '',
					zhuangXiuDetail: [],
					ruanZhuangDetail: [],
					sheBeiDetail: [],
					qiTaDetail: [],
				}],
				firstDataEdit: {
					storeName: '',
					zhuangXiu: '',
					ruanZhuang: '',
					sheBei: '',
					qiTa: '',
					zhuangXiuDetail: [],
					ruanZhuangDetail: [],
					sheBeiDetail: [],
					qiTaDetail: [],
					firstRemark: ""
				},
				lists: {},
				j: {},
				edata: {
					storeName: "",
					time: "",
					ftanFen: "",
					worker: "",
					workerDetail: [],
					guanLi: "",
					zuJin: "",
					shuiDian: "",
					zaFei: "",
					chaoJian: "",
					remark: ""
				},
				data: [{
					id: '',
					storeId: '',
					storeName: '',
					fzhuangXiu: '',
					fruanZhuang: '',
					fsheBei: '',
					fqiTa: '',
					ftanFen: '',
					workerDetail: [],
					guanLi: '',
					zuJin: '',
					shuiDian: '',
					zaFei: '',
					chaoJian: '',
					time: '',
					remark: ''
				}],
				query: {
					pageNum: 0,
					pageSize: 10,
					storeId: '',
					time: ''
				},
				query2: {
					pageNum: 0,
					pageSize: 10,
					total: 0,
					time: ''
				},
			};
		},
		mounted() {
			this.getList()
			this.getFirstList()
			this.getStore()
		},
		methods: {
			// 添加月度成本
			addmouthlist(num) {
				if (num == 1) {
					var a = {
						name: "",
						num: "",
						money: ""
					}
					this.edata.workerDetail.push(a)
				}
			},
			// 添加门店成本
			// 查询初始成本弹窗数据  编辑
			add() {
				this.dfirst = true
				this.firstDataEdit = {
					storeName: '',
					zhuangXiu: '',
					ruanZhuang: '',
					sheBei: '',
					qiTa: '',
					zhuangXiuDetail: [],
					ruanZhuangDetail: [],
					sheBeiDetail: [],
					qiTaDetail: [],
					firstRemark: ""
				}
			},
			add2() {
				this.dsecond = true
				this.edata = {
					storeName: "",
					time: "",
					ftanFen: "",
					workerDetail: [],
					guanLi: "",
					zuJin: "",
					shuiDian: "",
					zaFei: "",
					chaoJian: "",
					remark: ""
				}
			},
			downlist(value, list) {
				if (list == 1) {
					var list = this.firstDataEdit.zhuangXiuDetail
					list.splice(value, 1)
				}
				if (list == 2) {
					var list = this.firstDataEdit.ruanZhuangDetail
					list.splice(value, 1)
				}
				if (list == 3) {
					var list = this.firstDataEdit.sheBeiDetail
					list.splice(value, 1)
				}
				if (list == 4) {
					var list = this.firstDataEdit.qiTaDetail
					list.splice(value, 1)
				}
			},
			downmouthlist(value, list) {
				if (list == 1) {
					var list = this.edata.workerDetail
					list.splice(value, 1)
				}
			},
			addlist(value, ) {
				// this.dfirst=false
				var a = {
					name: "",
					num: "",
					money: ""
				}
				if (value == 1) {
					var list = this.firstDataEdit.zhuangXiuDetail
					list.push(a)
				} else if (value == 2) {
					var list = this.firstDataEdit.ruanZhuangDetail
					list.push(a)
				} else if (value == 3) {
					var list = this.firstDataEdit.sheBeiDetail
					list.push(a)
				} else if (value == 4) {
					var list = this.firstDataEdit.qiTaDetail
					list.push(a)
				}
			},
			getList(id) {
				var a = "?pageNum=" + this.query.pageNum + "&pageSize=" + this.query.pageSize + "&id=" + id + "&time=" +
					this.query.time + "&storeId=" + this.query.storeId
				this.$http.get("joinCost/list" + a).then(res => {
					let list = res.body.data;
					this.data = list;
					this.query.total = res.body.total
				})
			},
			getFirstList() {
				var a = "?pageNum=" + this.query2.pageNum + "&pageSize=" + this.query2.pageSize + "&time=" + this.query
					.time + "&storeId=" + this.query.storeId
				this.$http.get("joinCost/listFirst" + a).then(res => {
					if (res.body.code == 200) {
						this.firstData = res.body.data
						this.query2.total = res.body.total
						const data1 = this.firstData[0]
						const zx = data1.zhuangXiuDetail
						const {
							name,
							num,
							money
						} = zx;
					}
				})
			},
			getStore() {
				this.$http.get("store/list").then(res => {
					res.body.data = res.body.data.filter(ele => ele.businessType == 0)
					for (let i in res.body.data) {
						var a = {
							value: res.body.data[i].id,
							label: res.body.data[i].title
						}
						this.storeName.push(a)
					}
				})
			},
			handleSelect() {
				this.getList();
				this.getFirstList();
			},
			// 查询初始成本弹窗数据  编辑
			show1(id) {
				this.$http.get("joinCost/findFirst" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.firstDataEdit = res.body.data
						this.firstDataEdit.zhuangXiuDetail = this.firstDataEdit.zhuangXiuDetail ? JSON.parse(this
							.firstDataEdit.zhuangXiuDetail) : []
						this.firstDataEdit.ruanZhuangDetail = this.firstDataEdit.ruanZhuangDetail ? JSON.parse(this
							.firstDataEdit.ruanZhuangDetail) : []
						this.firstDataEdit.sheBeiDetail = this.firstDataEdit.sheBeiDetail ? JSON.parse(this
							.firstDataEdit.sheBeiDetail) : []
						this.firstDataEdit.qiTaDetail = this.firstDataEdit.qiTaDetail ? JSON.parse(this
							.firstDataEdit.qiTaDetail) : []
					}
				})
			},
			// 查询月度成本弹窗数据
			show2(id) {
				this.$http.get("joinCost/findCost" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.edata = res.body.data
						this.edata.workerDetail = JSON.parse(this.edata.workerDetail)
						this.dsecond = true
					}
				})
			},
			// 保存月度成本
			saveMonthCost() {
				// var index = id-1
				// var b = this.data[index]
				var b = this.edata
				let a = {
					type: 1,
					time: b.time,
					chaoJian: b.chaoJian ? b.chaoJian : 0,
					storeName: b.storeName,
					ftanFen: b.ftanFen ? b.ftanFen : 0,
					worker: b.worker ? b.worker : 0,
					workerDetail: JSON.stringify(b.workerDetail),
					guanLi: b.guanLi ? b.guanLi : 0,
					zuJin: b.zuJin ? b.zuJin : 0,
					shuiDian: b.shuiDian ? b.shuiDian : 0,
					zaFei: b.zaFei ? b.zaFei : 0,
					remark: b.remark
				}
				if (this.edata.id) {
					a.id = this.edata.id
					this.$http.post("joinCost/saveMonthCost", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("保存成功!")
							this.dsecond = false
							this.getList()
						} else {
							this.$message.error("保存失败!")
						}
					})
				} else {
					this.$http.post("joinCost/addCost", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("新建成功")
							// 关闭弹窗
							this.dsecond = false;
							// 更新数据
							this.getList()
						} else {
							this.$message.error(res.body.msg)
						}
					})
				}
			},
			// 保存初始成本
			saveFirstCost(id) {
				var b = this.firstDataEdit
				let a = {
					type: 0,
					zhuangXiu: b.zhuangXiu ? b.zhuangXiu : 0,
					storeName: b.storeName,
					sheBei: b.sheBei ? b.sheBei : 0,
					ruanZhuang: b.ruanZhuang ? b.ruanZhuang : 0,
					qiTa: b.qiTa ? b.qiTa : 0,
					zhuangXiuDetail: b.zhuangXiuDetail.length > 0 ? JSON.stringify(b.zhuangXiuDetail) : "",
					ruanZhuangDetail: b.ruanZhuangDetail.length > 0 ? JSON.stringify(b.ruanZhuangDetail) : "",
					sheBeiDetail: b.sheBeiDetail.length > 0 ? JSON.stringify(b.sheBeiDetail) : "",
					qiTaDetail: b.qiTaDetail.length > 0 ? JSON.stringify(b.qiTaDetail) : "",
					firstRemark: b.firstRemark
				}
				if (this.firstDataEdit.id) {
					a.id = this.firstDataEdit.id
					this.$http.post("joinCost/saveFirstCost", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("保存成功")
							// 关闭弹窗
							this.dfirst = false;
							// 更新数据
							this.getFirstList()
						} else {
							this.$message.error(res.body.msg)
						}
					})
				} else {
					this.$http.post("joinCost/addCost", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("新建成功")
							// 关闭弹窗
							this.dfirst = false;
							// 更新数据
							this.getFirstList()
						} else {
							this.$message.error(res.body.msg)
						}
					})
				}
			},
			// 导入
			exportin: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			// 文件上传
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				this.$http.post("joinCost/export", Formdata, config).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						this.getList()
						this.getFirstList()
					} else {
						this.$message.error(res.body.msg)
						this.$router.go(0);
					}
				})
			},
			// 导出
			exportout() {
				var a = "?time=" + this.query.time + "&storeId=" + this.query.storeId
				window.location.assign(this.url + "joinCost/expor" + a)
			},
			deleteFirst(id) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("joinCost/deleteFirst" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success(res.body.data)
							this.getFirstList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			deleteMonth(id) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("joinCost/deleteMonth" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success(res.body.data)
							this.getList()
						} else {
							this.$message.error(res.body.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleCurrentChange() {
				this.query.pageNum = val;
				this.getList();
			},
			handleCurrentChange01() {
				this.query2.pageNum = val;
				this.getListFirst();
			}
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 5px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.it_width {
		width: 250px;
	}

	.titlelist {
		display: flex;
		margin-left: 150px;
		position: relative;
		margin-bottom: 10px;
		top: -10px;
		width: 250px;
		text-align: center;

		div {
			flex: 1;
		}
	}
</style>